export default function ScholarshipOpportunitiesUSA() {
  return (
    <section className="w-full pb-16 px-4 sm:px-6 lg:px-16 bg-white">
      <div className="max-w-7xl mx-auto flex flex-col gap-12">
        
        {/* Heading */}
        <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900">
          Scholarship Opportunities to Study in the USA
        </h3>

        {/* Content */}
        <div className="text-justify space-y-4 text-gray-800 text-base sm:text-lg leading-relaxed">
          
          <p>
            Studying in the USA can be a significant financial investment. 
            However, hundreds of scholarship opportunities are available to 
            help international students reduce tuition fees and living expenses. 
            Many universities offer need-blind admissions, and both 
            government-funded and private scholarships are available for 
            Indian and other international students.
          </p>

          <p>
            With the right guidance, students can explore funding options 
            that make overseas education affordable and accessible. 
            Scholarships not only ease financial burdens but also 
            open doors to prestigious institutions and global career opportunities.
          </p>

          <p className="font-semibold text-gray-900">
            With the assistance of a USA Student Visa Consultant, you can:
          </p>

          <ul className="list-disc mx-6 space-y-2">
            <li>
              Identify scholarships suitable for your academic profile and course.
            </li>
            <li>
              Apply for funding to significantly reduce tuition and living costs.
            </li>
            <li>
              Explore government-funded, private, and university-based grants.
            </li>
            <li>
              Access affordable enrollment pathways and overseas opportunities.
            </li>
          </ul>

          <p>
            Begin your study abroad journey with expert financial planning 
            and professional guidance through Shivasya — one of the trusted 
            USA Student Visa Consultants in Ahmedabad — and move closer 
            to achieving your global education dreams.
          </p>

        </div>
      </div>
    </section>
  );
}